<script lang="ts">
	const getTime = () => new Date().toLocaleString();

	let time = getTime();
	setInterval(() => {
		time = getTime();
	});

	const getChars = (count: number) => {
		const demoChars = "abcdefABCDEF1234567890";
		let chars = [];
		for (let i = 0; i < count; i++) {
			chars.push(demoChars[Math.floor(Math.random() * demoChars.length)]);
		}
		return chars.join("");
	};

	let demoAddress = `0x${getChars(10)}...${getChars(10)}`;
	let hide = true;
	setInterval(() => {
		if (hide) {
			demoAddress = `0x${getChars(10)}...${getChars(10)}`;
		}
		hide = !hide;
	}, 5000);

	const address = new URL(window.location.href).searchParams.get("address");
</script>

<div
	class="bg-gray-50 min-h-screen relative bg-[url(/bg.gif)] bg-contain overflow-x-hidden"
>
	<div
		class="w-full min-h-screen px-2 py-12 lg:py-16 xl:py-20 bg-opacity-50 backdrop-blur-sm bg-black"
	>
		<div
			class="relative justify-center bg-opacity-70 bg-white overflow-hidden dark:bg-neutral-800 max-w-4xl p-6 rounded-md px-4 mx-auto flex flex-col gap-4 md:gap-8 items-center text-center"
		>
			<span
				class="text-sm absolute top-0 right-0 p-2 font-mono rounded-bl-md bg-gray-500 text-white"
				>airdrop is live</span
			>

			<h2
				class="p-2 absolute top-0 left-0 text-sm bg-gray-500 text-white rounded-br-md"
			>
				{time}
			</h2>
			<div class="space-y-2 mt-6">
				<h2
					class="text-3xl text-neutral-800 dark:text-gray-100 font-bold tracking-tighter sm:text-4xl md:text-5xl"
				>
					Connect your wallet to the whitelist
				</h2>
				<p
					class="max-w-[600px] text-gray-500 md:text-xl/none lg:text-base/none xl:text-xl dark:text-gray-400"
				>
					Enter your wallet address to join the whitelist for the
					upcoming presale event. Make sure you have $10 worth of BNB
					to claim authentication with the reward pool and whitelist.
				</p>
			</div>

			{#if Boolean(address)}
				<div
					class="p-4 shadow-sm shadow-gray-400 border border-gray-400 rounded-md flex flex-col gap-4 bg-black bg-opacity-15"
				>
					<div class="">
						<p class="text-xl mb-2 text-gray-100">Address</p>
						<div
							class="p-2 rounded-md bg-gray-100 border-gray-100 font-mono text-black bg-opacity-80 border"
						>
							{address}
						</div>
					</div>

					<div class="">
						<p class="text-xl mb-2 text-gray-100">Status</p>
						<span
							class="p-2 rounded-md font-mono bg-orange-500 text-white"
							>Unwhitelisted</span
						>
					</div>
				</div>
			{/if}

			<div class="w-full max-w-sm space-y-4 my-6">
				<button
					aria-label="robinkit-wc"
					class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-green-400 text-primary-foreground hover:bg-green-400/90 h-10 px-4 py-6 border border-green-600 w-full"
					>Whitelist Your Address</button
				>
			</div>

			<div
				class="mb-6 bg-red-600 bg-opacity-20 p-4 rounded-md border border-red-800"
			>
				<p class="text-sm italic text-red-400">
					Notice: The airdrop will end once 500 users whitelist or
					once the presale starts.
				</p>
			</div>

			<div
				class={"fixed right-0 bottom-0 p-6 max-w-sm transition-transform " +
					(hide ? "translate-x-full" : "")}
			>
				<div
					class="bg-green-500 text-white overflow-hidden font-mono rounded-md text-sm flex flex-col ease-linear duration-200 justify-start"
				>
					<h2
						class="flex justify-between align-middle place-items-center font-bold mb-1 p-2 border-b bg-white text-gray-950"
					>
						Address White-listed <svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							class="w-6 h-6 fill-green-500"
						>
							<path
								fill-rule="evenodd"
								d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
								clip-rule="evenodd"
							/>
						</svg>
					</h2>
					<p class="p-2">{demoAddress}</p>
				</div>
			</div>
		</div>
	</div>
</div>
